import { Prisma } from '@prisma/client';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { CommonFindResult } from '@app/infra-interfaces';
import { Axios } from '@app/web-components';

const URL = 'approval-stage';
const APPROVAL_STAGE_ALL_QUERY_KEY = 'APPROVAL_STAGE_ALL_QUERY_KEY';

export const approvalStageKeys = {
  all: [APPROVAL_STAGE_ALL_QUERY_KEY] as const,
  lists: () => [...approvalStageKeys.all, 'list'] as const,
  list: (filters: object) => [...approvalStageKeys.lists(), filters] as const,
  items: () => [...approvalStageKeys.all, 'item'] as const,
  item: (id: number | object | undefined) => [...approvalStageKeys.items(), id] as const,
};

export const useFindApprovalStages = <T>(
  args: Prisma.NodeAccessApprovalStageFindManyArgs,
  options?: Omit<UseQueryOptions<CommonFindResult<T>>, 'queryKey' | 'queryFn'>,
) => {
  const axios = Axios.useAxiosApi();

  return useQuery<CommonFindResult<T>>({
    ...options,
    queryKey: approvalStageKeys.list(args),
    queryFn: async () => {
      const { data } = await axios.post(`/${URL}/find`, args);
      return data;
    },
  });
};
